import React from 'react';
import Add from '@mui/icons-material/Add';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import AudienceChips from './audienceChips';

import styles from '../styles/formFieldAudienceChips.module.scss';

const FormFieldAudienceChips = ({
  audiences,
  isDisabled,
  menuItems,
  onChipClick,
}) => (
  <div className={styles.element}>
    {!isDisabled && (
      <div className={styles.menuContainer}>
        <Menu
          className={styles.menu}
          component={(
            <Button
              className={styles.button}
              color="brand"
              icon={<Add />}
              text={i18n.t('add-an-audience')}
            />
          )}
        >
          {menuItems}
        </Menu>
      </div>
    )}
    <AudienceChips
      audiences={audiences}
      isTypeOnly={isDisabled}
      onChipClick={onChipClick}
    />
  </div>
);

export default React.memo(FormFieldAudienceChips);
